module.exports = __webpack_public_path__ + "media/src/images/icons/flags/thailand-0c3264730287b497b449b32cf16cc3fd.svg";